'use client';

import CloseIcon from '@/components/_other/icons/CloseIcon';
import Modal from 'components/_other/modal/Modal';
import { CategoryFiltersSidebarSkeleton } from '@/app/components/loadings';
import useFilter, {
  arrayToParams,
  getSystemFilterAttributes,
} from '@/grandus-utils/hooks/useFilter';
import { getCategoryParametersBasic } from '@/grandus-lib/utils';
import { orderBy } from 'lodash/collection';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import slice from 'lodash/slice';
import { useEffect, useRef, useState } from 'react';
import ElementCheckbox from './categoryElements/CategoryElementCheckbox';
import CategoryElementCheckbox from './categoryElements/CategoryElementCheckbox';
import ElementPrice from './categoryElements/CategoryElementPrice';

import styles from './CategoryParameters.module.scss';
import FullParameters from './FullParameters';
import map from 'lodash/map';
import Link from 'next/link';
import pick from 'lodash/pick';
import { unset } from 'lodash';
import useStaticBlock from 'grandus-lib/hooks/useStaticBlock';
import lodashFilter from 'lodash/filter';
import indexOf from 'lodash/indexOf';
import { PRODUCT_PARAMETER_BLACKLIST } from '@/constants/ProductConstants';

// import CategoryMetaDescription from 'app/components/category/CategoryMetaDescription';
// import SideBarLoading from 'app/components/category/filter/SideBarLoading';

const modifyFilterData = filter => {
  if (isEmpty(filter)) {
    return null;
  }

  filter.brands = orderBy(filter?.brands, ['productCount'], ['desc']);

  return filter;
};

const CategoryParameters = ({
  initialData,
  isOpen,
  handleClose,
  handleGetData = false,
  category = null,
  parameters = [],
  parameterLimit = null,
  marketingCampaign = null,
  search = null,
}) => {
  const [categoryData, setCategoryData] = useState(null);
  const [opened, setOpened] = useState([]);
  const stickyRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const { staticBlocks } = useStaticBlock({
    group: 'parameter_image',
    expand: 'photo',
  });

  const handleClick = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const selected = { parameters: arrayToParams(map(parameters, i => decodeURIComponent(i))), category: category, search: search };

  const { filter, isLoading } = useFilter({
    category: category,
    parameters: parameters,
    marketingCampaign: marketingCampaign,
    search: search,
  });

  useEffect(() => {
    if (filter) {
      setCategoryData(modifyFilterData(filter));
    }
  }, [filter]);

  if ((isLoading || isDataLoading) && !categoryData) {
    return <CategoryFiltersSidebarSkeleton groupCount={5} />;
  }

  if (!categoryData) {
    return null;
  }

  const basicParametersList = parameterLimit
    ? slice(
      orderBy(
        getCategoryParametersBasic(categoryData),
        ['priority'],
        ['DESC'],
      ),
      0,
      parameterLimit,
    )
    : getCategoryParametersBasic(categoryData);

  const basicParameters = lodashFilter(basicParametersList, param => indexOf(PRODUCT_PARAMETER_BLACKLIST, param?.hash) === -1)

  const minPrice = get(
    categoryData,
    'selected.price.from.data.price',
    get(categoryData, 'minPrice', 0),
  );

  const maxPrice = get(
    categoryData,
    'selected.price.to.data.price',
    get(categoryData, 'maxPrice', 0),
  );

  let selectedMinPrice = minPrice;
  let selectedMaxPrice = maxPrice;
  if (selectedMinPrice > selectedMaxPrice) {
    selectedMinPrice = maxPrice;
    selectedMaxPrice = minPrice;
  }

  return (
    <div className={styles.wrapper}>
      <aside
        className={`${styles.sidebar} ${isLoading || isDataLoading ? styles.isLoading : ''} ${
          isOpen ? styles.active : ''
        }`}
        ref={stickyRef}
      >
        <div className={styles?.sidebarContent}>
          <div className={styles.filterTitle + ' d-block d-lg-none mb-3'}>
            <span className="h4 font-normal">Filter produktov</span>

            <button
              className={`${styles.closeButton} lg:hidden`}
              onClick={() => handleClose(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className={styles.item}>
            <ElementPrice
              key={`price-filter-${minPrice}-${maxPrice}`}
              {...getSystemFilterAttributes(
                get(categoryData, 'price', []),
                'cena',
                {
                  min: get(categoryData, 'minPrice'),
                  max: get(categoryData, 'maxPrice'),
                },
              )}
              selectedParams={selected}
              selected={{
                min: selectedMinPrice,
                max: selectedMaxPrice,
              }}
              category={category}
              search={search}
              getUrl={handleGetData}
              afterSelected={() => {
                //setIsDataLoading(true);
              }}
            />
          </div>

          {/* <CategoryElementCheckbox
            parameter={
              getSystemFilterAttributes(
                get(categoryData, 'availability', []).map(availability => {
                  return {
                    ...availability,
                    ...{ name: availability['v2-label'] ?? availability.name },
                  };
                }),
                'availability',
                {
                  selected,
                  styles,
                },
              )?.parameter
            }
            options={{ styles }}
            selected={selected}
            category={category}
            search={search}
            opened={opened}
            setOpened={setOpened}
          /> */}

          {basicParameters.map((parameter, index) => {
            const propsData = {
              parameter: parameter,
              options: {
                styles: styles,
              },
              setOpened: setOpened,
              opened: opened,
              category: category,
              search: search,
              selected: selected,
              handleGetData: handleGetData,
              parameterImages: staticBlocks
            };

            switch (parameter?.type) {
              default:
                return (
                  <ElementCheckbox
                    key={`category-${get(parameter, 'id')}-${index}`}
                    {...propsData}
                  />
                );
            }
          })}

          <div className={'text-center'}>
            <Link href={'#'} className={styles?.showAll} onClick={handleClick}>
              Všetky parametre
            </Link>
          </div>

          <Modal
            title={'Všetky parametre'}
            open={isModalOpen}
            onClose={handleCloseModal}
            closeByOutsideClick
          >
            <FullParameters
              category={category}
              categoryData={categoryData}
              selected={selected}
              styles={styles}
            />
          </Modal>

          <div className={styles.buttonWrapper}>
            <button className={'button'} onClick={() => handleClose(false)}>
              Zobraziť produkty
            </button>
          </div>
        </div>

        {/*<CategoryMetaDescription meta={filter?.meta} />*/}
      </aside>
    </div>
  );
};

export default CategoryParameters;
